export const ContestAttemptStatusType = {
    IN_PROGRESS: 'in_progress',
    PENDING_REVIEW: 'pending_review',
    COMPLETED: 'completed',
} as const;
export type ContestAttemptStatusTypeTypes = typeof ContestAttemptStatusType[keyof typeof ContestAttemptStatusType];